"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _translations = _interopRequireDefault(require("@jobmatchme/utils/es/translations"));

var _PersonAdd = _interopRequireDefault(require("@material-ui/icons/PersonAdd"));

var _Favorite = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LoadingComponent = function LoadingComponent(_ref) {
  var optimisticProfile = _ref.optimisticProfile,
      preventDataFetching = _ref.preventDataFetching,
      matchesLoadedCallback = _ref.matchesLoadedCallback,
      loadMatches = _ref.loadMatches;
  var ANNIMATION_DURATION = 9000;
  var t = (0, _translations.default)("pc-funnel:funnel.LoadingComponent");
  (0, _react.useEffect)(function () {
    var timer;

    var timerPromise = function timerPromise() {
      return new Promise(function (resolve) {
        timer = setTimeout(function () {
          resolve();
          matchesLoadedCallback([]);
        }, ANNIMATION_DURATION);
      });
    };

    if (optimisticProfile && !preventDataFetching) {
      Promise.all([loadMatches(optimisticProfile), timerPromise()]).then(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 1),
            matchesArray = _ref3[0];

        matchesLoadedCallback(matchesArray);
      });
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [loadMatches, matchesLoadedCallback, optimisticProfile, preventDataFetching]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    className: _styleModule.default.box,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      item: true,
      xs: 12,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
        className: _styleModule.default.headline,
        children: [t('headlineB'), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), t('headlineB2')]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: (0, _classnames.default)(_styleModule.default.text, _styleModule.default.delayedAnimation1),
        children: t('description')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        component: "div",
        className: (0, _classnames.default)(_styleModule.default.text, _styleModule.default.delayedAnimation2),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
          container: true,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 2,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _styleModule.default.lineIcon,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PersonAdd.default, {
                color: "primary",
                className: _styleModule.default.icon
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 10,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _styleModule.default.lineText,
              children: t('step1')
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        component: "div",
        className: (0, _classnames.default)(_styleModule.default.text, _styleModule.default.delayedAnimation3),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
          container: true,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 2,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _styleModule.default.lineIcon,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Search.default, {
                color: "primary",
                className: _styleModule.default.icon
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 10,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _styleModule.default.lineText,
              children: t('step2')
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        component: "div",
        className: (0, _classnames.default)(_styleModule.default.text, _styleModule.default.delayedAnimation4),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
          container: true,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 2,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _styleModule.default.lineIcon,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Favorite.default, {
                color: "primary",
                className: _styleModule.default.icon
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 10,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _styleModule.default.lineText,
              children: t('step3')
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        component: "div",
        className: (0, _classnames.default)(_styleModule.default.text, _styleModule.default.delayedAnimation5),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
          container: true,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 2,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _styleModule.default.lineIcon,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Phone.default, {
                color: "primary",
                className: _styleModule.default.icon
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 10,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _styleModule.default.lineText,
              children: t('step4')
            })
          })]
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.loaderWrapper,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {
        className: _styleModule.default.loader,
        color: "primary"
      })
    })]
  });
};

var _default = /*#__PURE__*/_react.default.memo(LoadingComponent);

exports.default = _default;